export const B2C_LOCAL_STORAGE_EMAIL = `userEmail_${import.meta.env.VITE_CLIENT_ID_B2C}`;
export const B2C_LOCAL_STORAGE_DOMAIN_HINT = `domainHint_${import.meta.env.VITE_CLIENT_ID_B2C}`;
export const LOCAL_STORAGE_LANGUAGE_KEY = 'language';
export const TIME_FORMAT_WITH_UTC = 'YYYY-MM-DDTHH:mm:ssZ';
export const TIME_FORMAT_WITH_HOUR = 'YYYY-MM-DDT23:59:59Z';
export const TIME_UTC_FORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_FORMAT_LTS = 'DD-MM-YYYY';

export const LOCAL_STORAGE_SOUND_ALERT = 'soundAlert';
export const LOCAL_STORAGE_WORKSPACE_ID = 'workspace_id';
export const LOCAL_STORAGE_ANALITICS = 'cases-expand';

export const B2C_POLICIES = {
  names: { signUpSignIn: import.meta.env.VITE_AUTH_POLICY },
  authorities: {
    signUpSignIn: {
      authority: `https://${import.meta.env.VITE_AUTH_TENANT}.b2clogin.com/${
        import.meta.env.VITE_AUTH_TENANT
      }.onmicrosoft.com/${import.meta.env.VITE_AUTH_POLICY}`,
    },
  },
  authorityDomain: `${import.meta.env.VITE_AUTH_TENANT}.b2clogin.com`,
};

export const AVAILABLE_LANGUAGES = {
  ENGLISH: 'en',
  PORTUGUESE: 'pt-BR',
  SPANISH: 'es',
} as const;

export const SENSOR_STATUS = {
  ACTIVE: 'ACTIVE',
  DELAYED: 'DELAYED',
  NO_DATA: 'NO_DATA',
  OFFLINE: 'OFFLINE',
} as const;

export const MODEL_TYPE = {
  CLASSIFICATION: 'classification',
  CLASSIFIER: 'classifier',
  CONDITION_BASED: 'condition_based',
  PDM: 'pdm',
  REGRESSION: 'regression',
  SCALING: 'scaling',
  SCALING_COUNTOUR: 'pdm/scaling/contour',
  SCALING_DEFAULT: 'pdm/scaling',
  SCALING_OPERATION_POINT: 'pdm/scaling/operating_point',
};

export const MODEL_STATUS = {
  OK: 'OK',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
};

export const PUMP_CURVE_KPI = {
  POWER_CALCULATED: 'power_calculated',
  POWER_EXPECTED: 'power_expected',
  DENSITY: 'density',
  EFFICIENCY: 'efficiency',
  EFFICIENCY_EXPECTED: 'efficiency_expected',
  ROTATION: 'rotation',
  FLOW_RATE: 'flow_rate',
  PRESSURE_DISCHARGE: 'pressure_discharge',
  BOX_LEVEL: 'box_level',
  NPSHA: 'npsha',
  NPSHR: 'npshr',
};

export const ASSET_CATEGORIES = {
  EQUIPMENT: 'equipment',
  PRESS: 'press',
  PUMP: 'pump',
  SENSORS: 'sensors',
  VET: 'vet',
  MODEL_VIEW: 'model_view',
};

export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
export const IS_DEVELOPMENT = ENVIRONMENT === 'development';
export const IS_PROD = ENVIRONMENT === 'production';
export const IS_LOCAL = ENVIRONMENT === 'local';
export const IS_DEMO = ENVIRONMENT === 'demo';

export const JARVIS_URL = import.meta.env.VITE_JARVIS_API_URL;

export const POSTHOG_URL =
  IS_LOCAL || IS_DEMO
    ? import.meta.env.VITE_PUBLIC_POSTHOG_HOST
    : `${window.location.origin}/posthog_proxy`;

export const DISPLAY_DIGITS_DEFAULT = -5;

export const ONE_MEGABYTE = 1024 * 1024;
export const MIXPANEL_EVENT_NAME = {
  LOGIN: 'Login',
  ACK: 'ACK',
};

export const TEMPLATES = {
  CASE_ACTIONS: 'Case Actions',
};
